import { useEffect } from 'react';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useDraftsAiSearchStore } from './useDraftsAiSearchStore';
export const useDraftsAiSearchPartialToast = (toastTestId)=>{
    const { showWarningToast } = useOverlayContext();
    const { t: warningTexts } = useLocaleKeys('pages.draftsDashboard.aiSearch.warnings');
    const searchPartial = useDraftsAiSearchStore((s)=>s.searchPartial);
    const setPartial = useDraftsAiSearchStore((s)=>s.setPartial);
    useEffect(()=>{
        if (searchPartial) {
            showWarningToast(warningTexts.partialCoverage(), toastTestId);
            setPartial(false);
        }
    }, [
        searchPartial,
        setPartial,
        toastTestId
    ]);
};
